import EditComp from "../component/EditComp";
import { fetchMutation } from "../../../actions";
import { CREATE_NOTES } from "../actions/notesAct";
import { ShowAlert } from "../../../common/alert";
import { errorToDisplay } from "../../../helper/CommonFuncs";
import { useState } from "react";

const EditCont = ({
   note,
   NoteId,
   setEditComponent,
   modifiedText,
   title,
   getGeneratedNotes = () => {},
   GetNotes = () => {},
}) => {
   const [loading, setLoading] = useState(false);
   const editNotes = (editedNote) => {
      setLoading(true);
      let notesObj = {
         createNotes: editedNote,
      };
      fetchMutation(
         CREATE_NOTES,
         notesObj,
         (res) => {
            getGeneratedNotes(NoteId);
            setEditComponent(false);
            GetNotes("", () => {}, true);
            const message = res?.data?.createNotes?.status?.message;
            ShowAlert(message);
            setLoading(false);
         },
         (error) => {
            setLoading(false);
            ShowAlert(errorToDisplay(error), "error");
         }
      );
   };

   return (
      <EditComp
         note={note}
         NoteId={NoteId}
         setEditComponent={setEditComponent}
         editNotes={editNotes}
         modifiedText={modifiedText}
         title={title}
         getGeneratedNotes={getGeneratedNotes}
         loading={loading}
      />
   );
};

export default EditCont;
